export const CompanyHeader = () => (
  <header className='pb-12 flex items-center flex-col gap-y-3'>
    <div className='overflow-hidden w-25 h-25'>
      <div className='animate-pulse bg-tertiary rounded-lg w-full h-full' />
    </div>
    <div className='flex flex-col gap-y-1 items-center'>
      <div className='w-48 h-6 bg-tertiary rounded-sm animate-pulse' />
      <div className='w-32 h-5 bg-tertiary rounded-sm animate-pulse' />
    </div>
  </header>
);
